
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartHighlightDataDependentIec as ObiChartHighlightDataDependentIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-highlight-data-dependent-iec.js';
 
 
 

 
 export const ObiChartHighlightDataDependentIec = createComponent({
   react: React,
   tagName: 'obi-chart-highlight-data-dependent-iec',
   elementClass: ObiChartHighlightDataDependentIecElement,
   events: {
     
   }
  });
 
 